'use client';
// src/app/not-found.tsx
import dynamic from 'next/dynamic';

// 中文：404 頁也交給 LegacyAppEntry，這樣有 <Routes>，Logo / Link 才能正常導航
// English: Render LegacyAppEntry even on 404 so <Routes> exist and logo/link navigation works
const LegacyAppEntryDynamic = dynamic(() => import('@/components/LegacyAppEntry'), {
    ssr: false,
});

export default function NotFound() {
    return <LegacyAppEntryDynamic />;
}
